import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackItemSaved = () => useTrackConversion({ goal: KameleoonGoalData.SavedItem });
